import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import FasterContent from '../assets/fasterContentCreation.svg';
import DaysOfWeek from '../assets/daysOfTheWeek.svg';
import HoursLegend from '../assets/hoursSpentLegend.svg';
import HoursGraph from '../assets/hoursSpentGraph.svg';
import TestimonialImage from '../assets/TestimonialImage.svg';

export const MasterLinkedIn: React.FC = () => {
  return (
    <Container
      fluid
      className="justify-content-center master-linkedin"
      style={{ paddingTop: 80, paddingBottom: 200 }}
    >
      <style>{`
        .master-linkedin__content {
          width: 80%;
          margin: 0 auto;
        }

        .master-linkedin__hours-legend {
          width: 50%;
          height: auto;
          max-width: 520px;
          margin-top: 16px;
          margin-bottom: 20px;
        }

        @media (max-width: 991.98px) {
          .master-linkedin {
            padding-left: 16px !important;
            padding-right: 16px !important;
            overflow-x: clip;
          }

          .master-linkedin > .row {
            --bs-gutter-x: 0;
            margin-left: 0;
            margin-right: 0;
          }

          .master-linkedin > .row > [class*='col-'] {
            padding-left: 0;
            padding-right: 0;
          }

          .master-linkedin__content {
            width: 100%;
          }

          .master-linkedin__content > .row {
            --bs-gutter-x: 0;
            margin-left: 0;
            margin-right: 0;
          }

          .master-linkedin__content > .row > [class*='col-'] {
            padding-left: 0;
            padding-right: 0;
          }

          .master-linkedin__heading {
            font-size: clamp(28px, 8vw, 48px);
            max-width: 100%;
          }

          .master-linkedin__hours-legend {
            display: block;
            margin-left: auto;
            margin-right: auto;
          }

          .master-linkedin__testimonial {
            flex-direction: column;
            align-items: center;
            text-align: center;
          }
        }
      `}</style>

      <Row className="w-100 justify-content-center">
        <Col xs={12} className="d-flex flex-column align-items-center text-center">
          <div
            className="master-linkedin__heading"
            style={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 500,
              fontSize: 48,
              lineHeight: '100%',
              letterSpacing: '-2%',
              color: '#FFFFFF',
            }}
          >
            Everything you need to master LinkedIn
          </div>
        </Col>
      </Row>

      <Row className="w-100 justify-content-center" style={{ marginTop: 90 }}>
        <Col xs={12}>
          <div className="master-linkedin__content">
            <Row className="g-3">
              <Col xs={12} lg={6} className="d-flex flex-column" style={{ gap: 12 }}>
                <div
                  style={{
                    background: 'transparent',
                    borderRadius: 15,
                    overflow: 'hidden',
                    border: '1px solid transparent',
                    backgroundImage:
                      'linear-gradient(transparent, transparent), linear-gradient(180deg, rgba(255, 255, 255, 0.0576) 0%, rgba(255, 255, 255, 0.0512) 100%)',
                    backgroundOrigin: 'border-box',
                    backgroundClip: 'padding-box, border-box',
                    boxShadow: 'inset 0px 0px 8px 0px #FFFFFF0A',
                    minHeight: 280,
                    padding: 20,
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <div
                    style={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 400,
                      fontSize: 24,
                      lineHeight: '32px',
                      color: '#FFFFFF',
                      textAlign: 'left',
                    }}
                  >
                    Streamline your creation process
                  </div>
                  <div
                    style={{
                      marginTop: 8,
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 400,
                      fontSize: 16,
                      lineHeight: '24px',
                      color: '#FFFFFF6B',
                      textAlign: 'left',
                      marginBottom: 70,
                    }}
                  >
                    Cero speeds up and simplifies your content creation. Save 90% of your content
                    creation time each week.
                  </div>
                  <div className="mt-auto">
                    <Image
                      src={FasterContent}
                      alt="Faster content creation"
                      style={{ width: '100%', height: 'auto' }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    background: 'transparent',
                    borderRadius: 15,
                    overflow: 'hidden',
                    border: '1px solid transparent',
                    backgroundImage:
                      'linear-gradient(transparent, transparent), linear-gradient(180deg, rgba(255, 255, 255, 0.0576) 0%, rgba(255, 255, 255, 0.0512) 100%)',
                    backgroundOrigin: 'border-box',
                    backgroundClip: 'padding-box, border-box',
                    boxShadow: 'inset 0px 0px 8px 0px #FFFFFF0A',
                    minHeight: 200,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    paddingTop: 24,
                    paddingBottom: 16,
                    paddingLeft: 16,
                    paddingRight: 16,
                  }}
                >
                  <Image
                    src={DaysOfWeek}
                    alt="days"
                    className="img-fluid"
                    style={{ width: '100%', maxWidth: 400, height: 'auto', marginTop: 20 }}
                  />
                  <div
                    style={{
                      marginTop: 16,
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 400,
                      fontSize: 22,
                      lineHeight: '32px',
                      color: '#FFFFFF',
                      textAlign: 'center',
                    }}
                  >
                    Finally post content consistenly
                  </div>
                </div>
              </Col>
              <Col xs={12} lg={6}>
                <div
                  style={{
                    background: 'transparent',
                    borderRadius: 15,
                    overflow: 'hidden',
                    border: '1px solid transparent',
                    backgroundImage:
                      'linear-gradient(transparent, transparent), linear-gradient(180deg, rgba(255, 255, 255, 0.0576) 0%, rgba(255, 255, 255, 0.0512) 100%)',
                    backgroundOrigin: 'border-box',
                    backgroundClip: 'padding-box, border-box',
                    boxShadow: 'inset 0px 0px 8px 0px #FFFFFF0A',
                    minHeight: 496,
                    padding: 20,
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <div
                    style={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 400,
                      fontSize: 24,
                      lineHeight: '32px',
                      color: '#FFFFFF',
                      textAlign: 'left',
                    }}
                  >
                    Maximize your earnings, minimize content costs
                  </div>
                  <div
                    style={{
                      marginTop: 8,
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 400,
                      fontSize: 16,
                      lineHeight: '24px',
                      color: '#FFFFFF6B',
                      textAlign: 'left',
                      marginBottom: 20,
                    }}
                  >
                    See how using Cero for content creation is more economical compared to the cost
                    of your time.
                  </div>
                  <Image
                    src={HoursLegend}
                    alt="Hours legend"
                    className="master-linkedin__hours-legend"
                  />
                  <Image
                    src={HoursGraph}
                    alt="Hours graph"
                    style={{ marginTop: 8, width: '100%', height: 'auto' }}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      <Row className="w-100 justify-content-center" style={{ marginTop: 40 }}>
        <Col xs={12} className="d-flex justify-content-center">
          <div className="master-linkedin__testimonial" style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <Image src={TestimonialImage} alt="Testimonial" style={{ width: 80, height: 'auto' }} />
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 400,
                  fontSize: 12,
                  lineHeight: '16px',
                  color: '#FFFFFF7A',
                }}
              >
                Albert Gallahal, Co-founder of Enorta Creatives
              </div>
              <div
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 400,
                  fontSize: 15,
                  lineHeight: '22px',
                  color: '#FFFFFF',
                }}
              >
                With Cero, I reclaimed 16 hours each week!
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};
